import { PaymentInfo } from 'typings/payment'
import { GET_PAYMENT_TRANSACTIONS } from 'redux/actionTypes'
import { PaymentAction } from './actions'

export const initState: PaymentInfo = {
  dataList: [],
  currentPage: 1,
  limit: 10,
  paymentCount: 1,
  isDataLoading: false,
  isPaymentResponseFail: false,
  errorMessage: '',
  error: false,
  gridOption: {
    columnID: '',
    currentPage: 1,
    limit: 10,
    sortColumn: '',
    sortOrder: ''
  },
  filterOption: {}
}

// eslint-disable-next-line default-param-last, @typescript-eslint/default-param-last
export default (state = initState, action: PaymentAction): PaymentInfo => {
  const { type, payload } = action

  if (type === GET_PAYMENT_TRANSACTIONS) {
    return {
      ...state,
      ...payload
    }
  }

  return state
}
